<template lang="pug">
.message-accordion
  b-card-header.p-2(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-message-detail'")
    span.toggle-text 入力依頼内容
  b-collapse(:id="'accordion-message-detail'" :accordion="'accordion-message-detail'" role="tabpanel")
    b-card-body
      // accepting status
      .mb-0
        span.key-name 受付状態
      #accepting-status.mb-3
        .mb-0
          span {{ _value.acceptingOtherUserReply }}
      // groupName
      .mb-0
        span.key-name 宛先
      #group-name.mb-3
        .mb-0
          span {{ _value.groupName }}
      // openingSentence
      .mb-0
        span.key-name メッセージ内容
      #opening-sentence
        .mb-0
          span {{ _value.openingSentence }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import AccordionLoading from "@/mobile/basics/AccordionLoading.vue";

/**
 * ### 安否確認送信(施設関係者)のメッセージ内容
 */
@Component({
  components: {
    AccordionLoading
  }
})
export default class MessageAccordion extends Vue {
  /** 表示対象(既読家族、未読家族) */
  @Prop({ required: true })
  value!: MessageAccordionModel;

  get _value(): MessageAccordionModel {
    return this.value;
  }
}

export interface MessageAccordionModel {
  /** 受付状態 */
  acceptingOtherUserReply: string;
  /** 宛先 */
  groupName: string;
  /** メッセージ内容 */
  openingSentence: string;
}
</script>
